<div style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini stats-container u-bg-primary {{ sectionclass }}"
	>
		<div *ngIf="hasLiftData; else noLiftDataBlock">
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header"
			>
				<div class="o-stack__cell">
					<h5>{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="date-range-banner" *ngIf="showDateRangeBanner">
				<div class="banner-content">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="14"
						height="14"
						viewBox="0 0 14 14"
						fill="none"
						style="margin-right: 8px; flex-shrink: 0"
					>
						<path
							d="M5.83333 7C5.83333 6.72386 6.05719 6.5 6.33333 6.5H7C7.27614 6.5 7.5 6.72386 7.5 7V10.3333C7.5 10.6095 7.27614 10.8333 7 10.8333C6.72386 10.8333 6.5 10.6095 6.5 10.3333V7.5H6.33333C6.05719 7.5 5.83333 7.27614 5.83333 7Z"
							fill="#00AAFF"
						/>
						<path
							d="M6.83267 3.83333C6.46583 3.83333 6.16497 4.13099 6.16667 4.50181C6.16765 4.86912 6.4658 5.16667 6.83333 5.16667C7.20148 5.16667 7.5 4.86814 7.5 4.5C7.5 4.13056 7.20017 3.83333 6.83267 3.83333Z"
							fill="#00AAFF"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M0.5 7C0.5 3.40986 3.40986 0.5 7 0.5C10.5901 0.5 13.5 3.40986 13.5 7C13.5 10.5901 10.5901 13.5 7 13.5C3.40986 13.5 0.5 10.5901 0.5 7ZM7 1.5C3.96214 1.5 1.5 3.96214 1.5 7C1.5 10.0379 3.96214 12.5 7 12.5C10.0379 12.5 12.5 10.0379 12.5 7C12.5 3.96214 10.0379 1.5 7 1.5Z"
							fill="#00AAFF"
						/>
					</svg>
					<div class="banner-text">
						Some lift values may be skewed due to historical data limits (only past 2 years + 1 quarter available)
					</div>
				</div>
			</div>
			<div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content stats_content">
				<div class="o-stack o-stack--center _u-px-small lift_stats">
					<div class="o-stack__cell content_mainCls">
						<h5>Digital Lift</h5>
						<span class="u-font-medium u-lh-normal u-opacity-80p stats_value" *ngIf="liftStatsData"
							>{{ liftStatsData.digitalLift }}x</span
						>
					</div>
					<div class="o-stack__cell content_mainCls">
						<h5>Exposed Rate</h5>
						<span class="u-font-medium u-lh-normal u-opacity-80p stats_value" *ngIf="liftStatsData"
							>{{ liftStatsData.exposedRate }}%</span
						>
					</div>
					<div class="o-stack__cell content_mainCls">
						<h5>Baseline Rate</h5>
						<span class="u-font-medium u-lh-normal u-opacity-80p stats_value" *ngIf="liftStatsData"
							>{{ liftStatsData.baseLineRate }}%</span
						>
					</div>
				</div>
				<div class="content_mainCls lift_stats_subsection">
					People who saw your digital ads were
					<b>
						<span *ngIf="liftStatsData">{{ liftStatsData.digitalLift }}</span> times more likely to visit your website
					</b>
					than the unexposed audience
				</div>
				<div class="no-data-container" *ngIf="!hasData">
					<div>
						<div class="display_lift_no_data_header">
							<div
								class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header"
							>
								<div class="o-stack__cell">
									<h5>{{ sectiontitle }}</h5>
								</div>
							</div>
						</div>
					</div>
					<div class="map-no-data">No Data to Display</div>
				</div>
			</div>
		</div>
		<ng-template #noLiftDataBlock>
			<div
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header no_lift_data_header"
			>
				<div class="o-stack__cell">
					<h5>{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="analytics-portlet-content u-px-small no_lift_data_block stats_content">
				<div class="lift_stats_subhead r6_lift_stats_subhead">
					Campaigns in the selected date range are not eligible for lift reporting.
				</div>
				<div class="lift_stats_sub_section">
					<div class="lift_stats_subhead" style="padding-top: 5px">
						A campaign must meet all of the following 3 requirements to receive lift reporting:
					</div>
					<div>
						<ul class="lift_stats_list">
							<li>- Campaign must have the pixel placed and firing on the website</li>
							<li>- Campaign must run for 3 consecutive months</li>
							<li>- Campaign must run at least 50,000 audience extension impressions per month</li>
						</ul>
					</div>
				</div>
			</div>
		</ng-template>
	</div>
</div>
